import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "41",
  height: "40",
  viewBox: "0 0 41 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.38211 0C1.75985 0 0.444824 1.28329 0.444824 2.86535V37.1347C0.444824 38.7172 1.75985 40 3.38211 40H37.2553C38.8775 40 40.1926 38.7172 40.1926 37.1347V2.86535C40.1926 1.28329 38.8775 0 37.2553 0H3.38211ZM12.4936 15.4219V33.4841H6.49007V15.4219H12.4936ZM12.8884 9.83551C12.8884 11.5688 11.5854 12.9558 9.49182 12.9558H9.45269C7.43796 12.9558 6.13518 11.5688 6.13518 9.83551C6.13518 8.06317 7.4779 6.71468 9.53154 6.71468C11.5854 6.71468 12.8494 8.06317 12.8884 9.83551ZM21.819 33.4841H15.8155C15.8155 33.4841 15.8945 17.1167 15.8157 15.4219H21.8192V17.9792L21.7791 18.0414H21.8192V17.9792C22.617 16.7484 24.0449 14.9981 27.2296 14.9981C31.1795 14.9981 34.1413 17.5796 34.1413 23.1275V33.4841H28.1383V23.8213C28.1383 21.3931 27.2693 19.7368 25.0969 19.7368C23.4384 19.7368 22.4506 20.8538 22.0166 21.9324C21.858 22.3183 21.819 22.8576 21.819 23.3974V33.4841Z",
      fill: "#0077B5"
    }, null, -1)
  ])))
}
export default { render: render }